import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import FaqSection from '../Section/FaqSection';
import DepartmentSection from '../Section/DepartmentSection';
import { pageTitle } from '../../helpers/PageTitle';
import servicesData from '../../data/services';

const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Compassion',
    subTitle:
      'I aim to create a calm, welcoming space where every patient feels heard, respected, and at ease throughout their visit.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Excellence',
    subTitle:
      'I am committed to evidence-based medicine and ongoing learning so that every consultation reflects current best practice.',
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Integrity',
    subTitle:
      'I practise with honesty and transparency, explaining diagnoses, options, and costs clearly so you can make informed decisions.',
  },
  {
    iconSrc: '/images/home_1/respect.svg',
    title: 'Respect',
    subTitle:
      'Every patient is treated with dignity, regardless of background or circumstance. Your time and concerns matter.',
  },
  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Continuity',
    subTitle:
      'As your family doctor, I work alongside specialists, pharmacists, and allied professionals to coordinate consistent care.',
  },
];

const faqData = [
  {
    title: 'What conditions does Dr. Ramiah treat?',
    content:
      'As a general practitioner, I see patients of all ages for routine illnesses, chronic disease management, preventive care, vaccinations, minor injuries, and general well-being concerns. For specialist conditions I will refer you to a trusted colleague.',
  },
  {
    title: 'Do I need an appointment?',
    content:
      'Walk-ins are accommodated when possible, but booking ahead is recommended to reduce waiting time. Please call the practice during operating hours to arrange a suitable time.',
  },
  {
    title: 'Do you accept medical aid?',
    content:
      'Most major medical aid schemes are accepted. Please bring your medical aid card and ID to your visit, and contact the practice ahead of time if you would like to confirm your scheme.',
  },
  {
    title: 'What should I bring to a consultation?',
    content:
      'Please bring a valid form of ID, your medical aid card if applicable, a list of any current medications, and any recent test results or referral letters from other practitioners.',
  },
];

export default function Home() {
  pageTitle('Dr. L.D. Ramiah | Home');
  return (
    <>
      <Hero
        title="Dr. L.D. Ramiah"
        subTitle="Family medicine and primary healthcare in Wyebank, Durban."
        bgUrl="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_1/hero_img.png"
        infoList={[
          {
            title: 'Phone',
            subTitle: '(+27) 31 711 0082',
            iconUrl: '/images/contact/icon_1.svg',
          },
          {
            title: 'Hours',
            subTitle: 'Mon–Fri 08:00–17:00',
            iconUrl: '/images/icons/ambulance.svg',
          },
          {
            title: 'Location',
            subTitle: '5 Motala Rd, Wyebank',
            iconUrl: '/images/icons/pin.svg',
          },
        ]}
        btnText="Contact"
        btnUrl="/contact"
      />
      {/* Start Values Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Values" data={featureListData} />
      </Section>
      {/* End Values Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About the Practice"
          subTitle="DR. L.D. RAMIAH"
          featureList={[
            {
              featureListTitle:
                'A family doctor caring for the Wyebank community.',
              featureListSubTitle:
                'I provide comprehensive primary healthcare for individuals and families, combining careful listening, thorough examination, and clear explanations so you leave each visit better informed about your health.',
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Services Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Services"
          bgUrl="images/home_1/department_bg.svg"
          data={servicesData.slice(0, 6)}
        />
      </Section>
      {/* End Services Section */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/cta_img.png"
          title="Have a question?"
          subTitle="Get in touch with the practice and we will respond as soon as we can."
        />
      </Section>
      {/* End Banner Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105} bottomMd={200} bottomLg={150} bottomXl={110}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section>
      {/* End FAQ Section */}
    </>
  );
}
